// import React, { useEffect, useState } from "react";
// import {
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   IconButton,
//   Grid,
//   Box,
//   Typography,
// } from "@mui/material";
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import { Add, Edit, Delete } from "@mui/icons-material";
// import { getProjectsByUserId, getSiteMgmtByMgmtId } from "../../api/project";
// import { useSelector } from "react-redux";
// import { showSuccess } from "../../actions/alert";
// import {
//   getAllSiteCountbyProject,
//   insertSiteForProjectData,
// } from "../../api/siteManagement";
// import { getallSitesData } from "../../api/sites";

// const siteTypes = ["Residential", "Commercial", "Industrial", "Infrastructure"];
// const initialSite = {
//   site_id: null,
//   project_id: "",
//   name: "",
//   location: "",
//   siteType: "",
//   manager: "",
//   start_date: "",
//   end_date: "",
//   progress: "",
//   notes: "",
// };

// export default function SitesManagement() {
//   const user = useSelector((state) => state.user);
//   const [sites, setSites] = useState([]);
//   const [sitesData, setSitesData] = useState([]);
//   const [formData, setFormData] = useState(initialSite);
//   const [open, setOpen] = useState(false);
//   const [editMode, setEditMode] = useState(false);
//   const [projectId, setProjectId] = useState("");
//   const [projects, setProjects] = useState([]);

//   const handleChange = (e) =>
//     setFormData({ ...formData, [e.target.name]: e.target.value });

//   const handleSave = async () => {
//     if (!editMode) {
//       try {
//         const { data } = await insertSiteForProjectData(formData, user.token);
//         if (data.status) {
//           // setSites(
//           //   sites.map((site) => (site.id === formData.id ? formData : site))
//           // )
//           showSuccess("Site Created Successfully");
//         }
//       } catch (error) {
//         console.error("Error updating site:", error);
//       }
//     } else {
//       setSites([...sites, { ...formData, id: Date.now() }]);
//     }
//     setOpen(false);
//   };

//   const handleEdit = (site) => {
//     setFormData(site);
//     setEditMode(true);
//     setOpen(true);
//   };

//   const handleDelete = (id) => setSites(sites.filter((site) => site.id !== id));

//   useEffect(() => {
//     projectList();
//   }, []);
//     useEffect(() => {
//       if(formData.id) {
//     getSiteMgmtbyID();
//       }
//   }, [formData?.id]);

//   const getSiteMgmtbyID=()=>{
//     getSiteMgmtByMgmtId(formData.id, user.token)
//       .then((res) => {
//         if (res.data.status) {
//           // setSites(res.data.data);
//           console.log("Site Management Data:", res.data.data);
//           setFormData({...res.data})
//         }
//       })
//       .catch((err) => console.error("Error fetching site management data:", err));
//   }
//   const projectList = () => {
//     getProjectsByUserId("me", {}, user.token)
//       .then((res) => {
//         setProjects(res.data.data);
//       })
//       .catch((err) => console.error("Error fetching projects:", err));
//   };

//   const fetchSitesManagementData = async () => {
//     try {
//       const { data } = await getAllSiteCountbyProject(user.token, {});
//       if (data.status) {
//         setSites(data.data);
//       }
//     } catch (error) {
//       console.error("Error fetching sites:", error);
//     }
//   };

//   useEffect(() => {
//     fetchSitesManagementData();
//     FetchAllSites();
//   }, [user.token]);

//   const FetchAllSites = async () => {
//     try {
//       const { data } = await getallSitesData(
//         // { projectId: projectId },
//         user.token
//       );
//       if (data.status) {
//         setSitesData(data.data);
//       }
//     } catch (error) {
//       console.error("Error fetching all sites:", error);
//     }
//   };

//   return (
//     <>
//       <Box className="pmt-title-box">
//         <Box className="typography-title">
//           <Typography variant="h1" className="pmt-headings-h1">
//             Site Management
//           </Typography>
//         </Box>
//         <Button
//           variant="contained"
//           style={{ padding: "5px 7px" }}
//           className="blue-button"
//           startIcon={<Add />}
//           onClick={() => {
//             setFormData(initialSite);
//             setEditMode(false);
//             setOpen(true);
//           }}
//         >
//           Add Site
//         </Button>
//       </Box>

//       <TableContainer component={Paper} sx={{ mt: 2 }}>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>Actions</TableCell>

//               <TableCell>Project Name</TableCell>
//               {/* <TableCell>Site Name</TableCell> */}
//               <TableCell>Sites</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {sites.map((site) => (
//               <TableRow key={site.id}>
//                 <TableCell>
//                   {/* <IconButton onClick={() => handleEdit(site)}>
//                     <Edit />
//                   </IconButton> */}
//                   {/* <IconButton onClick={() => handleDelete(site.id)}>
//                     <Delete />
//                   </IconButton> */}
//                       <IconButton color="info" onClick={() => { }} >
//                 <VisibilityIcon fontSize='inherit' />
//             </IconButton>
//                 </TableCell>
//                 <TableCell>{site.project_name}</TableCell>
//                 {/* <TableCell>{site.site_name}</TableCell> */}
//                 <TableCell>{site.site_count}</TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       <Dialog
//         open={open}
//         onClose={() => setOpen(false)}
//         fullWidth
//         maxWidth="md"
//       >
//         <DialogTitle>{editMode ? "Edit Site" : "Add Site"}</DialogTitle>
//         <DialogContent>
//           <Grid container spacing={2} sx={{ mt: 1 }}>
//             <Grid item xs={12} sm={6}>
//               <FormControl fullWidth>
//                 <InputLabel>Project</InputLabel>
//                 <Select
//                   name="project_id"
//                   value={formData.project_id}
//                   onChange={handleChange}
//                   label="Project"
//                 >
//                   <MenuItem value="">
//                     <em>Select Project</em>
//                   </MenuItem>
//                   {projects.map((p, i) => (
//                     <MenuItem key={i} value={p.project_id}>
//                       {p.project_name}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <FormControl fullWidth>
//                 <InputLabel>Site</InputLabel>
//                 <Select
//                   name="site_id"
//                   value={formData.site_id}
//                   onChange={handleChange}
//                 >
//                   <MenuItem value="">
//                     <em>Select Site</em>
//                   </MenuItem>
//                   {sitesData.map((site) => (
//                     <MenuItem key={site.site_id} value={site.site_id}>
//                       {site.site_name}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={6}>
//               <TextField
//                 name="location"
//                 label="Location"
//                 fullWidth
//                 value={formData.location}
//                 onChange={handleChange}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6}>
//               <FormControl fullWidth>
//                 <InputLabel>Site Type</InputLabel>
//                 <Select
//                   name="siteType"
//                   value={formData.siteType}
//                   onChange={handleChange}
//                   label="Site Type"
//                 >
//                   <MenuItem value="">
//                     <em>Select Site Type</em>
//                   </MenuItem>
//                   {siteTypes.map((type) => (
//                     <MenuItem key={type} value={type}>
//                       {type}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={6}>
//               <TextField
//                 name="manager"
//                 label="Manager"
//                 fullWidth
//                 value={formData.manager}
//                 onChange={handleChange}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6}>
//               <TextField
//                 name="progress"
//                 label="Progress (%)"
//                 type="number"
//                 fullWidth
//                 value={formData.progress}
//                 onChange={handleChange}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6}>
//               <TextField
//                 name="start_date"
//                 label="Start Date"
//                 type="date"
//                 fullWidth
//                 InputLabelProps={{ shrink: true }}
//                 value={formData.start_date}
//                 onChange={handleChange}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6}>
//               <TextField
//                 name="end_date"
//                 label="End Date"
//                 type="date"
//                 fullWidth
//                 InputLabelProps={{ shrink: true }}
//                 value={formData.end_date}
//                 onChange={handleChange}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <TextField
//                 name="notes"
//                 label="Notes"
//                 fullWidth
//                 multiline
//                 minRows={2}
//                 value={formData.notes}
//                 onChange={handleChange}
//               />
//             </Grid>
//           </Grid>
//         </DialogContent>

//         <DialogActions>
//           <Button onClick={() => setOpen(false)}>Cancel</Button>
//           <Button onClick={handleSave} variant="contained">
//             {editMode ? "Update" : "Save"}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// }

import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Grid,
  Box,
  Typography,
  CircularProgress,
  Collapse,
  Chip,
  Card,
  CardContent,
  Avatar,
  LinearProgress,
  Divider,
  Tooltip,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { Add, Clear, Search } from "@mui/icons-material";
import PersonIcon from "@mui/icons-material/Person";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import NotesIcon from "@mui/icons-material/Notes";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { useDispatch, useSelector } from "react-redux";
import { showAlert, showSuccess } from "../../actions/alert";

import {
  getProjectList,
  getProjectsByUserId,
  getSiteMgmtByMgmtId,
  getSitesMgmtbyProjectID,
} from "../../api/project";
import {
  getAllSiteCountbyProject,
  insertSiteForProjectData,
} from "../../api/siteManagement";
import { getallSitesData } from "../../api/sites";
import { handleAxiosError } from "../../config/action-config";

const siteTypes = ["Residential", "Commercial", "Industrial", "Infrastructure"];
const initialSite = {
  site_id: null,
  project_id: "",
  name: "",
  location: "",
  siteType: "",
  manager: "",
  start_date: "",
  end_date: "",
  progress: "",
  notes: "",
};

export default function SitesManagement() {
  const user = useSelector((state) => state.user);
  const [sites, setSites] = useState([]);
  const [sitesData, setSitesData] = useState([]);
  const [formData, setFormData] = useState(initialSite);
  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [projects, setProjects] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [expandedRows, setExpandedRows] = useState({});
  const [subTableData, setSubTableData] = useState({});
  const [loadingRows, setLoadingRows] = useState({});
  const dispatch = useDispatch();
  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSave = async () => {
    if (!editMode) {
      try {
        const { data } = await insertSiteForProjectData(formData, user.token);
        if (data.status) {
          dispatch(showAlert("Site Created Successfully"));
          // showSuccess();
          fetchSitesManagementData();
        }
      } catch (error) {
        console.error("Error updating site:", error);
        handleAxiosError(error, dispatch);
      }
    }
    setOpen(false);
  };

  const handleToggleSubTable = async (id) => {
    const isOpen = expandedRows[id];

    if (isOpen) {
      setExpandedRows((prev) => ({ ...prev, [id]: false }));
    } else {
      setLoadingRows((prev) => ({ ...prev, [id]: true }));
      try {
        const { data } = await getSitesMgmtbyProjectID(id, user.token);
        if (data.status) {
          setSubTableData((prev) => ({ ...prev, [id]: data.data }));
          setExpandedRows((prev) => ({ ...prev, [id]: true }));
        }
      } catch (err) {
        console.error("Error fetching sub table:", err);
      } finally {
        setLoadingRows((prev) => ({ ...prev, [id]: false }));
      }
    }
  };

  const handleEdit = (site) => {
    setFormData(site);
    setEditMode(true);
    setOpen(true);
  };

  const projectList = () => {
    getProjectList(user.token)
      .then((res) => setProjects(res.data.data))
      .catch((err) => console.error("Error fetching projects:", err));
  };

  const fetchSitesManagementData = async () => {
    try {
      const { data } = await getAllSiteCountbyProject(user.token, {
        project_name: searchTerm,
      });
      if (data.status) {
        setSites(data.data);
      }
    } catch (error) {
      console.error("Error fetching sites:", error);
    }
  };

  const FetchAllSites = async () => {
    try {
      const { data } = await getSitesMgmtbyProjectID(formData.project_id,user.token);
      if (data.status) {
        setSitesData(data.data);
      }
    } catch (error) {
      console.error("Error fetching all sites:", error);
    }
  };

  const getProgressColor = (progress) => {
    if (progress >= 80) return "success";
    if (progress >= 60) return "info";
    if (progress >= 40) return "warning";
    return "error";
  };

  const getSiteTypeColor = (siteType) => {
    const colors = {
      Residential: "primary",
      Commercial: "secondary",
      Industrial: "warning",
      Infrastructure: "info",
    };
    return colors[siteType] || "default";
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };
  useEffect(() => {
    if (formData.project_id) {
      FetchAllSites();
    }
  }, [formData.project_id]);
  useEffect(() => {
    projectList();
    fetchSitesManagementData();
  }, [user.token, searchTerm]);

  return (
    <>
      <Box className="pmt-title-box">
        <Box className="typography-title">
          <Typography variant="h1" className="pmt-headings-h1">
            Site Management
          </Typography>
        </Box>
        <Button
          variant="contained"
          className="blue-button"
          startIcon={<Add />}
          onClick={() => {
            setFormData(initialSite);
            setEditMode(false);
            setOpen(true);
          }}
        >
          Add Site
        </Button>
      </Box>
      <div className="bg-white rounded-xl p-4 mb-[8px] shadow-lg border mt-2 border-gray-100">
        <div className="flex flex-wrap items-center gap-4">
          <div className="relative">
            <Search
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
              size={20}
            />
            <input
              type="text"
              placeholder="Search by project Name"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none min-w-64"
            />
          </div>

          {/* <select
            value={filterBy}
            onChange={(e) => setFilterBy(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none min-w-48"
          >
            <option value="all">All Projects</option>
            {projectNames.map(name => (
              <option key={name} value={name}>{name}</option>
            ))}
          </select> */}
          {/*
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
          >
            <option value="project_name">Sort by Name</option>
            <option value="site_count">Sort by Site Count</option>
          </select> */}

          <button
            onClick={() => setSearchTerm("")}
            className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <Clear size={16} />
            Clear
          </button>
        </div>
      </div>
      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Actions</TableCell>
              <TableCell>Project Name</TableCell>
              <TableCell>Sites</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sites.map((site) => (
              <React.Fragment key={site.id}>
                <TableRow>
                  <TableCell>
                    <IconButton
                      color="info"
                      onClick={() => handleToggleSubTable(site.id)}
                    >
                      {expandedRows[site.id] ? (
                        <VisibilityOffIcon fontSize="small" />
                      ) : (
                        <VisibilityIcon fontSize="small" />
                      )}
                    </IconButton>
                  </TableCell>
                  <TableCell>{site.project_name}</TableCell>
                  <TableCell>
                    <Chip
                      label={`${site.site_count} Sites`}
                      color="primary"
                      size="small"
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell colSpan={3} sx={{ p: 0, bgcolor: "#f8f9fa" }}>
                    <Collapse
                      in={expandedRows[site.id]}
                      timeout="auto"
                      unmountOnExit
                    >
                      <Box sx={{ p: 3 }}>
                        {loadingRows[site.id] ? (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              py: 4,
                            }}
                          >
                            <CircularProgress size={32} />
                            <Typography sx={{ ml: 2 }}>
                              Loading site details...
                            </Typography>
                          </Box>
                        ) : (
                          <Box style={{ zoom: "0.75" }}>
                            <Typography
                              variant="h6"
                              sx={{ mb: 2, color: "primary.main" }}
                            >
                              Site Details for {site.project_name}
                            </Typography>
                            <Divider sx={{ mb: 2 }} />

                            {(subTableData[site.id] || []).length === 0 ? (
                              <Box
                                sx={{
                                  textAlign: "center",
                                  py: 4,
                                  color: "text.secondary",
                                }}
                              >
                                <Typography variant="body1">
                                  No sites found for this project
                                </Typography>
                              </Box>
                            ) : (
                              <Grid container spacing={2}>
                                {(subTableData[site.id] || []).map((s, idx) => (
                                  <Grid item xs={12} md={3} lg={3} key={idx}>
                                    <Card
                                      sx={{
                                        height: "100%",
                                        transition: "all 0.3s ease",
                                        "&:hover": {
                                          transform: "translateY(-4px)",
                                          boxShadow: 4,
                                        },
                                      }}
                                    >
                                      <CardContent>
                                        <Box
                                          sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "flex-start",
                                            mb: 2,
                                          }}
                                        >
                                          <Typography
                                            variant="h6"
                                            component="h3"
                                            sx={{ fontWeight: 600 }}
                                          >
                                            {s.site_name}
                                          </Typography>
                                          <Chip
                                            label={s.siteType || "N/A"}
                                            color={getSiteTypeColor(s.siteType)}
                                            size="small"
                                          />
                                        </Box>

                                        <Box sx={{ mb: 2 }}>
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              mb: 1,
                                            }}
                                          >
                                            <PersonIcon
                                              sx={{
                                                mr: 1,
                                                color: "text.secondary",
                                                fontSize: 16,
                                              }}
                                            />
                                            <Typography variant="body2">
                                              <strong>Manager:</strong>{" "}
                                              {s.manager || "Not assigned"}
                                            </Typography>
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              mb: 1,
                                            }}
                                          >
                                            <CalendarTodayIcon
                                              sx={{
                                                mr: 1,
                                                color: "text.secondary",
                                                fontSize: 16,
                                              }}
                                            />
                                            <Typography variant="body2">
                                              <strong>Duration:</strong>{" "}
                                              {formatDate(s.start_date)} -{" "}
                                              {formatDate(s.end_date)}
                                            </Typography>
                                          </Box>
                                        </Box>

                                        <Box sx={{ mb: 2 }}>
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "space-between",
                                              mb: 1,
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                              }}
                                            >
                                              <TrendingUpIcon
                                                sx={{
                                                  mr: 1,
                                                  color: "text.secondary",
                                                  fontSize: 16,
                                                }}
                                              />
                                              <Typography variant="body2">
                                                <strong>Progress</strong>
                                              </Typography>
                                            </Box>
                                            <Chip
                                              label={`${s.progress || 0}%`}
                                              color={getProgressColor(
                                                s.progress
                                              )}
                                              size="small"
                                              variant="filled"
                                            />
                                          </Box>
                                          <LinearProgress
                                            variant="determinate"
                                            value={s.progress || 0}
                                            color={getProgressColor(s.progress)}
                                            sx={{ height: 8, borderRadius: 4 }}
                                          />
                                        </Box>

                                        {s.notes && (
                                          <Box>
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                mb: 1,
                                              }}
                                            >
                                              <NotesIcon
                                                sx={{
                                                  mr: 1,
                                                  color: "text.secondary",
                                                  fontSize: 16,
                                                }}
                                              />
                                              <Typography variant="body2">
                                                <strong>Notes:</strong>
                                              </Typography>
                                            </Box>
                                            <Typography
                                              variant="body2"
                                              sx={{
                                                color: "text.secondary",
                                                fontStyle: "italic",
                                                backgroundColor: "#f5f5f5",
                                                p: 1,
                                                borderRadius: 1,
                                                fontSize: "0.85rem",
                                              }}
                                            >
                                              {s.notes}
                                            </Typography>
                                          </Box>
                                        )}
                                      </CardContent>
                                    </Card>
                                  </Grid>
                                ))}
                              </Grid>
                            )}
                          </Box>
                        )}
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Dialog unchanged */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>{editMode ? "Edit Site" : "Add Site"}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Project</InputLabel>
                <Select
                  name="project_id"
                  value={formData.project_id}
                  onChange={handleChange}
                  label="Project"
                >
                  <MenuItem value="">
                    <em>Select Project</em>
                  </MenuItem>
                  {projects.map((p, i) => (
                    <MenuItem key={i} value={p.id}>
                      {p.project_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Site</InputLabel>
                <Select
                  name="site_id"
                  value={formData.site_id}
                  onChange={handleChange}
                >
                  <MenuItem value="">
                    <em>Select Site</em>
                  </MenuItem>
                  {sitesData.map((site) => (
                    <MenuItem key={site.site_id} value={site.site_id}>
                      {site.site_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Site Type</InputLabel>
                <Select
                  name="siteType"
                  value={formData.siteType}
                  onChange={handleChange}
                  label="Site Type"
                >
                  <MenuItem value="">
                    <em>Select Site Type</em>
                  </MenuItem>
                  {siteTypes.map((type) => (
                    <MenuItem key={type} value={type}>
                      {type}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="manager"
                label="Manager"
                fullWidth
                value={formData.manager}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="progress"
                label="Progress (%)"
                type="number"
                fullWidth
                value={formData.progress}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="start_date"
                label="Start Date"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={formData.start_date}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="end_date"
                label="End Date"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={formData.end_date}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                name="notes"
                label="Notes"
                fullWidth
                multiline
                minRows={2}
                value={formData.notes}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={handleSave} variant="contained">
            {editMode ? "Update" : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
